/* eslint-disable jira/filename-case */
export const TRACE_ID_HEADER = 'atl-traceid';
const TRACE_ID_HEADER_MICROS = 'x-trace-id';
export const KNOWN_TRACE_ID_HEADERS: string[] = [TRACE_ID_HEADER, TRACE_ID_HEADER_MICROS];
